import React, {Component} from "react";
import {connect} from "react-redux";
import {msg, type_modal, type_modal_icon} from "../../vars/rd";
import {modalHide} from "../../libs/redux/actions/modal";

class Modal extends Component {
    constructor(props) {
        super(props);
        this.msg = msg();
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    get modal() {
        return this.props.hasOwnProperty("modal") ? this.props.modal : {};
    }

    /**
     * 노출여부
     * @returns {boolean}
     */
    get display() {
        try {
            return this.modal.display;
        } catch (e) {
        }
        return false;
    }

    /**
     * 팝업 코드
     * @returns {string}
     */
    get code() {
        try {
            return this.modal.code;
        } catch (e) {
        }
        return '';
    }

    /**
     * 팝업 데이터
     * @returns {null|{icon: string, header: string, message: string, buttons:{yes, no}, immunity: boolean}}
     */
    get data() {
        try {
            return this.modal.data;
        } catch (e) {
        }
        return null;
    }

    get icon() {
        try {
            const data = this.data;
            return data.icon || type_modal_icon.none;
        } catch (e) {}
        return null;
    }

    get header() {
        try {
            const data = this.data;
            const header = data.header;
            if(header) return header;
        } catch (e) {}

        switch (this.code) {
            case type_modal.confirm:
                return this.msg.confirm;
            case type_modal.alert:
                return this.msg.alert;
            default:
                return this.msg.alert;
        }
    }

    get message() {
        try {
            const data = this.data;
            return data.message || '';
        } catch (e) {}
        return "";
    }

    get buttons() {
        try {
            const data = this.data;
            return data.buttons || null;
        } catch (e) {}
        return "";
    }

    get immunity() {
        try {
            const data = this.data;
            return data.immunity || false;
        } catch (e) {}
        return "";
    }

    /**
     *
     * @returns {Function|null}
     */
    get callback() {
        try {
            return this.modal.callback;
        } catch (e) {
        }
        return null;
    }

    callbackCall(returnValue) {
        try {
            const callback = this.callback;
            if(callback) {
                callback.call(this, returnValue);
            }
        } catch (e) {
        } finally {
            this.dispatch(modalHide());
        }
    }

    /**
     * 아이콘 요소
     * @returns {JSX.Element|null}
     */
    get icon_contents() {
        switch (this.icon) {
            case type_modal_icon.warn:
                return <span><img src="/images/icon-warning.png" alt="" /></span>
            case type_modal_icon.check:
                return <span><img src="/images/icon-check.png" alt="" /></span>
            case type_modal_icon.error:
                return <span><img src="/images/icon-error.png" alt="" /></span>
            default:
                return null;
        }
    }

    /**
     * 해더 요소
     * @returns {JSX.Element}
     */
    get header_contents() {
        const icon = this.icon_contents;
        if(!icon) {
            return <h3>
                {this.header}
            </h3>;
        } else {
            return <h2>
                {icon}
                {this.header}
            </h2>;
        }
    }

    /**
     * 메세지 요소
     * @returns {JSX.Element}
     */
    get message_contents() {
        return <div className="popup-text" dangerouslySetInnerHTML={{ __html: this.message }} />;
    }

    /**
     * 버튼요소
     * @returns {JSX.Element}
     */
    get button_contents() {
        if(this.immunity) return null;

        const buttons = this.buttons;
        const button_yes = (buttons && buttons.hasOwnProperty("yes")) ? buttons.yes : this.msg.btn_yes;
        const button_no = (buttons && buttons.hasOwnProperty("no")) ? buttons.no : this.msg.btn_no;

        switch (this.code) {
            case type_modal.confirm:
                return <div className="popup-btn-wrap">
                    <span className="btn-s btn-t1"
                          onClick={() => this.callbackCall(false)}>
                        {button_no}
                    </span>
                    <span className={`btn-s btn-p1 ${this.icon}`}
                          onClick={() => this.callbackCall(true)}>
                        {button_yes}
                    </span>
                </div>;
            default:
                return <div className="popup-btn-wrap">
                    <span className={`btn-s btn-p1 ${this.icon}`}
                          onClick={() => this.callbackCall(true)}>
                        {button_yes}
                    </span>
                </div>;
        }
    }

    /**
     * 팝업 컨텐츠
     * @returns {JSX.Element|null}
     */
    get contents() {
        switch (this.code) {
            case type_modal.alert:
            case type_modal.warn:
                return <div className={'popup'}>
                    {this.header_contents}
                    {this.message_contents}
                    {this.button_contents}
                </div>;
            case type_modal.confirm:
                return <div className={'popup'}>
                    {this.header_contents}
                    {this.message_contents}
                    {this.button_contents}
                </div>;
            default:
                return null;
        }
    }

    /**
     * 팝업 렌더링
     * @returns {JSX.Element}
     */
    render() {
        return (
            <div className={`popup-confirm ${this.display ? '' : 'hide'}`}>
                {this.contents}
                <div className="popup-confirm-bg"></div>
            </div>
        )
    }
}

const modalStateToProps = (state) => ({
    modal: state.modal,
});

export default connect(modalStateToProps)(Modal);


// WEBPACK FOOTER //
// ./src/pages/include/modal.jsx